export default __webpack_public_path__ + "static/media/threeDots.e4a94dce.svg";